export class AsignacionSedeDto {
    idAsignacion: number;
    idTipoAsignacion: number;
    idListaServicio: number;
    idListaEquipo: number;
    idPlataforma: number;
    idRol: number;
    observaciones: string;
    idDireccionIp: number;
    configuracionDns: string;
    idCompania: number;
    indiacdorHabilitado: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/asignacion-sede-dto.ts